import _ from "lodash";
const parseJson = value => {
  try {
    return JSON.parse(value);
  } catch (e) {
    return value;
  }
};

const stringifyJson = value => {
  try {
    return JSON.stringify(value);
  } catch (e) {
    return value;
  }
};

const shallowCompare = ({ currentState, nextState }) => {
  if (currentState === nextState) {
    return true;
  }

  if (
    typeof prevState !== "object" ||
    currentState === null ||
    typeof nextObj !== "object" ||
    nextState === null
  ) {
    return false;
  }

  const prevStateProperties = _.keys(currentState);
  const nextStateProperties = _.keys(nextState);

  if (prevStateProperties.length !== nextStateProperties.length) {
    return false;
  }

  return _.every(
    prevStateProperties,
    key => _.has(nextState, key) && currentState[key] === nextState[key]
  );
};

const deepCompare = ({ currentProps, nextProps }) =>
  !_.isEqual(currentProps, nextProps);

const shouldUpdateForProps = ({ currentProps, nextProps, isMemo = false }) => {
  // Check if the sets of keys are the same in both this.props and nextProps
  const currentKeys = Object.keys(currentProps);
  const nextKeys = Object.keys(nextProps);
  if (
    currentKeys.length !== nextKeys.length ||
    !_.every(currentKeys, key => _.has(nextProps, key))
  ) {
    // when used inside second parameter of React.memo, it will return opposite of shouldComponentUpdate
    return isMemo ? false : true;
  }

  // deep compare props
  const shouldUpdateForProps = deepCompare({ currentProps, nextProps });

  // when used inside second parameter of React.memo, it will return opposite of shouldComponentUpdate
  return isMemo ? !shouldUpdateForProps : shouldUpdateForProps;
};

const shouldUpdateForState = ({ currentState, nextState }) => {
  // shallow compare state
  const shouldUpdateForState = !shallowCompare({ currentState, nextState });

  return shouldUpdateForState;
};

const promiseAllObject = async promiseObj => {
  const promises = await Promise.all(_.values(promiseObj));
  return _.zipObject(_.keys(promiseObj), promises);
};

const getItemBeforeAndAfter = (arr, id) => {
  const index = _.findIndex(arr, { id });

  if (index === -1) {
    return { before: null, after: null };
  }

  const before = index > 0 ? arr[index - 1] : null;
  const after = index < _.size(arr) - 1 ? arr[index + 1] : null;

  return { before, after };
};

const insertAfterId = (array, idToInsertAfter, elementToInsert) => {
  const index = _.findIndex(array, { id: idToInsertAfter });

  if (index === -1) {
    return [...array];
  }

  const newArray = [...array];
  newArray.splice(index + 1, 0, elementToInsert);

  return newArray;
};

const insertBeforeId = (array, idToInsertBefore, elementToInsert) => {
  const index = _.findIndex(array, { id: idToInsertBefore });

  if (index === -1) {
    return [...array];
  }

  const newArray = [...array];
  newArray.splice(index, 0, elementToInsert);

  return newArray;
};

const parseConfigurationValue = configuration => {
  const { valueType, value } = configuration || {};
  switch (valueType) {
    case "BOOLEAN":
      //we are adding this "NA" in a special case to notify the user that the configuration u are trying to use is disabled by admin
      return value === "NA" ? "NA" : value === "true";
    case "JSON":
    case "ARRAY":
    case "TEXT": //TODO remove this before commiting to develop
      return parseJson(value);
    default:
      return value;
  }
};

export {
  parseJson,
  stringifyJson,
  shallowCompare,
  shouldUpdateForProps,
  shouldUpdateForState,
  promiseAllObject,
  getItemBeforeAndAfter,
  insertAfterId,
  insertBeforeId,
  parseConfigurationValue,
};
